let lastCartState = {
    discountJSON: null,
    totalPrice: null,
    subtotalContent: ""
  };
  
  function updateCartTotal(priceInCents) {
    try {
      const formattedPrice = `$${(priceInCents / 100).toFixed(2)}`;
      const priceElement = document.querySelector('.side-cart-total-price .amount');
      if (priceElement) {
        priceElement.textContent = formattedPrice;
      }
    } catch (e) {}
  }
  
  function fetchAndUpdateCartIfNeeded() {
    try {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          try {
            const discountJSON = JSON.stringify(cart.cart_level_discount_applications);
            const totalPrice = cart.total_price;
  
            const isDiscountChanged = discountJSON !== lastCartState.discountJSON;
            const isTotalChanged = totalPrice !== lastCartState.totalPrice;
  
            if (isDiscountChanged || isTotalChanged) {
              updateCartTotal(totalPrice);
              lastCartState.discountJSON = discountJSON;
              lastCartState.totalPrice = totalPrice;
            }
          } catch (e) {}
        })
        .catch(() => {});
    } catch (e) {}
  }
  
  function watchDiscountContainer() {
    try {
      const container = document.querySelector('.lit__subtotal_discounts');
      if (!container) return;
  
      const observer = new MutationObserver(() => {
        try {
          const allCellText = Array.from(container.querySelectorAll('.lit__subtotal_row_cell'))
            .map(cell => cell.textContent.trim())
            .join('|');
  
          if (allCellText !== lastCartState.subtotalContent) {
            lastCartState.subtotalContent = allCellText;
            fetchAndUpdateCartIfNeeded();
          }
        } catch (e) {}
      });
  
      observer.observe(container, {
        childList: true,
        subtree: true,
        characterData: true
      });
    } catch (e) {}
  }
  
  function startSidecartPolling() {
    try {
      setInterval(() => {
        try {
          const sidecart = document.querySelector('.side-panel.cart-drawer.has-shadow--true.active');
          if (sidecart) {
            fetchAndUpdateCartIfNeeded();
          }
        } catch (e) {}
      }, 2000);
    } catch (e) {}
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    try {
      watchDiscountContainer();
      startSidecartPolling();
    } catch (e) {}
  });

(function waitForDiscountFunctions() {
  try {
    const interval = setInterval(() => {
      const hasHandleClick = typeof window.lit_discount__handleClick === 'function';
      const hasClearDiscount = typeof window.lit_discount__clearDiscount === 'function';

      if (hasHandleClick && hasClearDiscount) {
        clearInterval(interval); // stop polling

        const fetchDiscountStatus = () => {
          const openMiniCart = true; // Assuming this is what you intended
          fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: {
                  cart,
                  openMiniCart
                }
              }));
            })
            .catch(err => {
              // Error handling removed as requested
            });
        };

        // Wrap lit_discount__handleClick
        const originalHandleClick = window.lit_discount__handleClick;
        window.lit_discount__handleClick = function (...args) {
          setTimeout(fetchDiscountStatus, 500); // Wait 500ms before fetching
          return originalHandleClick.apply(this, args);
        };

        // Wrap lit_discount__clearDiscount
        const originalClearDiscount = window.lit_discount__clearDiscount;
        window.lit_discount__clearDiscount = function (...args) {
          setTimeout(fetchDiscountStatus, 500); // Wait 500ms before fetching
          return originalClearDiscount.apply(this, args);
        };

        // Wrap lit_discount__handleKeyDown
        const originalHandleKeyDown = window.lit_discount__handleKeyDown;
        window.lit_discount__handleKeyDown = function(event) { // The 'onkeydown' likely passes the event object
          // Check if the Enter key was pressed
          if (event.key === 'Enter' || event.keyCode === 13) {
            setTimeout(fetchDiscountStatus, 500);
          }
          // Always call the original function, ensuring its logic runs
          // 'arguments' ensures all original arguments are passed through
          return originalHandleKeyDown.apply(this, arguments);
        };
      }
    }, 200); // check every 200ms
  } catch (error) {
    // Error handling removed as requested
  }
})();